// @flow
import React from 'react'
import { Link } from 'react-router-dom'

export const EmailSent = (): any => {
  return (
    <div className='pw-reset-password'>
      <span className='login__accent' />
      <div className='login__header'>
        <h3 className='login__title'>Check your inbox</h3>
        <h4 className='login__subtitle'>A recovery email has been sent to your address.</h4>
      </div>
      <Link to='/' className='pw-reset-password__login'>Return to Login Page</Link>
    </div>
  )
}

EmailSent.displayName = 'EmailSent'

export default EmailSent
